import * as types from '../../action-types';
import { getAllOffers as initialState } from "../../initialState";

const getAllOffers  = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_OFFERS_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_ALL_OFFERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_ALL_OFFERS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_ALL_OFFERS_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getAllOffers ;
